import { forwardRef, useState } from 'react';
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { PublicAuditLog } from 'api';
import LogDetailDialog from './LogDetailDialog';
import LogRow from './LogRow';

const LogsTable = forwardRef<
  HTMLDivElement,
  {
    logs: PublicAuditLog[];
    loadMore: () => Promise<void>;
    isLoadingMore: boolean;
    hasNextPage: boolean;
      }
      >(({ logs, loadMore, isLoadingMore, hasNextPage }, ref) => {
        const [selectedLog, setSelectedLog] = useState<PublicAuditLog | null>(null);
        const [open, setOpen] = useState(false);
        if (logs.length === 0) {
          return (
            <Typography variant="h5" sx={{ mt: 4 }}>
        No audit logs found for the selected criteria. Please adjust your filters and try again.
            </Typography>
          );
        }

        return (
          <>
            <TableContainer ref={ref} sx={{ maxHeight: 600 }} component={Paper}>
              <Table stickyHeader sx={{ tableLayout: 'fixed' }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: '14%' }}>Timestamp</TableCell>
                    <TableCell sx={{ width: '14%' }}>User</TableCell>
                    <TableCell sx={{ width: '8%' }}>Feature</TableCell>
                    <TableCell sx={{ width: '8%' }}>Company</TableCell>
                    <TableCell sx={{ width: '16%' }}>Object Modified</TableCell>
                    <TableCell sx={{ width: '8%' }}>Action</TableCell>
                    <TableCell sx={{ width: '32%' }}>Details</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {logs.map(log => (
                    <LogRow
                      log={log}
                      key={`${log.created_at}-${log.id}-logrow`}
                      onExpandHandler={() => {
                        setSelectedLog(log);
                        setOpen(true);
                      }}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {hasNextPage && (
              <Button onClick={loadMore} disabled={isLoadingMore} fullWidth>
                {isLoadingMore ? 'Loading...' : 'Load More'}
              </Button>
            )}
            {selectedLog && (
              <LogDetailDialog open={open} onClose={() => setOpen(false)} changedPayload={selectedLog.changed_payload} />
            )}
          </>
        );
      });
LogsTable.displayName = 'LogsTable';

export default LogsTable;
